import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import React, { Component } from 'react';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import Select from "react-select";
import GlobalHelper from '../../../../common/GlobalHelper.jsx';
import RichTextEditor from "../../../../common/rich-text/editor.component.jsx";
import { UNIT_GROUP_TYPES } from "../../../../state/pricing/UnitGroupTypes";
import ProposalMergeFields from "../../../../template/MergeFields.jsx";
import SectionSettingCheckbox from "../common/InputCheckboxComponent.tsx";

const messages = defineMessages({
    "templates.sections.form.edit.content.pricing_table.product_title_size_small_label": {
        id: 'templates.sections.form.edit.content.pricing_table.product_title_size_small_label',
        defaultMessage: 'Small',
    },
    "templates.sections.form.edit.content.pricing_table.product_title_size_medium_label": {
        id: 'templates.sections.form.edit.content.pricing_table.product_title_size_medium_label',
        defaultMessage: 'Medium',
    },
    "templates.sections.form.edit.content.pricing_table.product_title_size_large_label": {
        id: 'templates.sections.form.edit.content.pricing_table.product_title_size_large_label',
        defaultMessage: 'Large',
    },
    "preview_header_label": {
        id: 'templates.sections.form.edit.content.pricing_table.preview_header_label',
        defaultMessage: 'Header',
    },
    "header_label_placeholder": {
        id: 'templates.sections.form.edit.content.pricing_table.header_placeholder_label',
        defaultMessage: 'The name of this header',
    },
    "grouped_quantity_unit": {
        id: "templates.sections.form.edit.content.pricing_table.grouped_quantity_unit",
        defaultMessage: "Unit",
    },
    "grouped_quantity_time": {
        id: "templates.sections.form.edit.content.pricing_table.grouped_quantity_time",
        defaultMessage: "Time",
    },
    "quantity_group_select_placeholder": {
        id: "templates.sections.form.edit.content.pricing_table.grouped_quantity_placeholder_label",
        defaultMessage: "Choose unit group type(s)",
    },

})

class PricingTableContentInput extends Component {

    constructor(props, context) {
        super(props, context)
        const content = this.props.value || {}

        this.state = {
            className: this.props.className || '',
            onChange: this.props.onChange || function () {
            },
            showTaxes: content.showTaxes || false,
            showLineSubTotal: content.showLineSubTotal || false,
            showShortDescription: content.showShortDescription || false,
            showLongDescription: content.showLongDescription || false,
            showUnitPrice: content.showUnitPrice || false,
            showUnitPriceWithoutDiscount: content.showUnitPriceWithoutDiscount || false,
            showSku: content.showSku || false,
            showBundleSkus: content.showBundleSkus || false,
            showManufacturer: content.showManufacturer || false,
            showProductLabels: content.showProductLabels || false,
            showVendorLabels: content.showVendorLabels || false,
            showBrandLabel: content.showBrandLabel || false,
            showTotalQuantitiesByUnitGroup: content.showTotalQuantitiesByUnitGroup || false,
            disableInteractive: content.disableInteractive || false,
            hideDeposit: content.hideDeposit || false,
            hideSerialNumber: content.hideSerialNumber || false,
            hideImages: content.hideImages || false,
            hideFiles: content.hideFiles || false,
            hideItems: content.hideItems || false,
            hideCalendarEvents: content.hideCalendarEvents || false,
            hideTotals: content.hideTotals || false,
            productTitleSize: content.productTitleSize || 'medium',
            hideGroupSubtotal: content.hideGroupSubtotal || false,
            hideDueDate: content.hideDueDate || false,
            customLineHeaderLabel1: content.customLineHeaderLabel1 || '',
            customLineHeaderLabel2: content.customLineHeaderLabel2 || '',
            customLineHeaderLabel3: content.customLineHeaderLabel3 || '',
            customLineHeaderLabel4: content.customLineHeaderLabel4 || '',
            customLineText1: content.customLineText1 || '',
            customLineText2: content.customLineText2 || '',
            customLineText3: content.customLineText3 || '',
            customLineText4: content.customLineText4 || '',
            showCustomLine: content.showCustomLine || false,
            enableCollapsibleGroups: content.enableCollapsibleGroups || false,
            enableSingleCollapsibleGroups: content.enableSingleCollapsibleGroups || false,
            showGroupInclusiveSubtotal: content.showGroupInclusiveSubtotal || false,
            showGroupDescription: content.showGroupDescription || false,
            showProductPageUrl: content.showProductPageUrl || false,
            unitGroupsToDisplay: content.unitGroupsToDisplay || [],
            defaultUnitGroupsToDisplay: [
                { value: UNIT_GROUP_TYPES.UNIT, label: this.props.intl.formatMessage(messages["grouped_quantity_unit"]) },
                { value: UNIT_GROUP_TYPES.TIME, label: this.props.intl.formatMessage(messages["grouped_quantity_time"]) }
            ]
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleTextChangeColumn1 = this.handleTextChangeColumn1.bind(this)
        this.handleTextChangeColumn2 = this.handleTextChangeColumn2.bind(this)
        this.handleTextChangeColumn3 = this.handleTextChangeColumn3.bind(this)
        this.handleTextChangeColumn4 = this.handleTextChangeColumn4.bind(this)
        this.handleQuantitiesSelectChange = this.handleQuantitiesSelectChange.bind(this)
    }

    triggerChanged() {
        this.state.onChange({
            showTaxes: this.state.showTaxes,
            showLineSubTotal: this.state.showLineSubTotal,
            showShortDescription: this.state.showShortDescription,
            showLongDescription: this.state.showLongDescription,
            showUnitPrice: this.state.showUnitPrice,
            showUnitPriceWithoutDiscount: this.state.showUnitPriceWithoutDiscount,
            showSku: this.state.showSku,
            showBundleSkus: this.state.showBundleSkus,
            showManufacturer: this.state.showManufacturer,
            showProductLabels: this.state.showProductLabels,
            showVendorLabels: this.state.showVendorLabels,
            showBrandLabel: this.state.showBrandLabel,
            showTotalQuantitiesByUnitGroup: this.state.showTotalQuantitiesByUnitGroup,
            disableInteractive: this.state.disableInteractive,
            hideDeposit: this.state.hideDeposit,
            hideSerialNumber: this.state.hideSerialNumber,
            hideImages: this.state.hideImages,
            hideFiles: this.state.hideFiles,
            hideItems: this.state.hideItems,
            hideCalendarEvents: this.state.hideCalendarEvents,
            hideTotals: this.state.hideTotals,
            productTitleSize: this.state.productTitleSize,
            customLineHeaderLabel1: this.state.customLineHeaderLabel1,
            customLineHeaderLabel2: this.state.customLineHeaderLabel2,
            customLineHeaderLabel3: this.state.customLineHeaderLabel3,
            customLineHeaderLabel4: this.state.customLineHeaderLabel4,
            customLineText1: this.state.customLineText1,
            customLineText2: this.state.customLineText2,
            customLineText3: this.state.customLineText3,
            customLineText4: this.state.customLineText4,
            showCustomLine: this.state.showCustomLine,
            enableCollapsibleGroups: this.state.enableCollapsibleGroups,
            enableSingleCollapsibleGroups: this.state.enableSingleCollapsibleGroups,
            hideGroupSubtotal: this.state.hideGroupSubtotal,
            hideDueDate: this.state.hideDueDate,
            showGroupInclusiveSubtotal: this.state.showGroupInclusiveSubtotal,
            showGroupDescription: this.state.showGroupDescription,
            showProductPageUrl: this.state.showProductPageUrl,
            unitGroupsToDisplay: this.state.unitGroupsToDisplay,
            defaultUnitGroupsToDisplay: this.state.defaultUnitGroupsToDisplay
        })
    }

    componentDidMount() {
        this.triggerChanged()
    }

    componentWillReceiveProps(nextProps) {
        const content = nextProps.value || {}
        this.setState({
            showTaxes: content.showTaxes || false,
            showLineSubTotal: content.showLineSubTotal || false,
            showShortDescription: content.showShortDescription || false,
            showLongDescription: content.showLongDescription || false,
            showUnitPrice: content.showUnitPrice || false,
            showUnitPriceWithoutDiscount: content.showUnitPriceWithoutDiscount || false,
            showSku: content.showSku || false,
            showManufacturer: content.showManufacturer || false,
            showProductLabels: content.showProductLabels || false,
            showVendorLabels: content.showVendorLabels || false,
            showBrandLabel: content.showBrandLabel || false,
            showTotalQuantitiesByUnitGroup: content.showTotalQuantitiesByUnitGroup || false,
            disableInteractive: content.disableInteractive || false,
            hideDeposit: content.hideDeposit || false,
            hideSerialNumber: content.hideSerialNumber || false,
            hideImages: content.hideImages || false,
            hideFiles: content.hideFiles || false,
            hideItems: content.hideItems || false,
            hideCalendarEvents: content.hideCalendarEvents || false,
            hideTotals: content.hideTotals || false,
            productTitleSize: content.productTitleSize || 'medium',
            customLineHeaderLabel1: content.customLineHeaderLabel1 || '',
            customLineHeaderLabel2: content.customLineHeaderLabel2 || '',
            customLineHeaderLabel3: content.customLineHeaderLabel3 || '',
            customLineHeaderLabel4: content.customLineHeaderLabel4 || '',
            customLineText1: content.customLineText1 || '',
            customLineText2: content.customLineText2 || '',
            customLineText3: content.customLineText3 || '',
            customLineText4: content.customLineText4 || '',
            showCustomLine: content.showCustomLine || false,
            enableCollapsibleGroups: content.enableCollapsibleGroups || false,
            enableSingleCollapsibleGroups: content.enableSingleCollapsibleGroups || false,
            hideGroupSubtotal: content.hideGroupSubtotal || false,
            hideDueDate: content.hideDueDate || false,
            showGroupInclusiveSubtotal: content.showGroupInclusiveSubtotal || false,
            showGroupDescription: content.showGroupDescription || false,
            showProductPageUrl: content.showProductPageUrl || false,
            unitGroupsToDisplay: content.unitGroupsToDisplay || [],
            defaultUnitGroupsToDisplay: content.defaultUnitGroupsToDisplay || []
        })
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value
        }, this.triggerChanged)
    }

    handleTextChangeColumn1(value) {
        this.setState({
            customLineText1: value
        }, this.triggerChanged)
    }

    handleTextChangeColumn2(value) {
        this.setState({
            customLineText2: value
        }, this.triggerChanged)
    }

    handleTextChangeColumn3(value) {
        this.setState({
            customLineText3: value
        }, this.triggerChanged)
    }

    handleTextChangeColumn4(value) {
        this.setState({
            customLineText4: value
        }, this.triggerChanged)
    }

    handleQuantitiesSelectChange(selectedOptions) {
        if (!this.state.showTotalQuantitiesByUnitGroup) {
            return
        }

        let options = selectedOptions.map(option => option.value)
        this.setState({ unitGroupsToDisplay: options }, this.triggerChanged)
    }

    render() {
        return (
            <div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="productTitleSize">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.pricing_table.product_title_size_label"
                            defaultMessage="Product title size"
                        />
                    </label>
                    <div className="col-10">
                        <select
                            name="productTitleSize"
                            value={this.state.productTitleSize}
                            onChange={this.handleFormChange}
                            id="productTitleSize"
                            className="form-control"
                        >
                            <option value="small">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.pricing_table.product_title_size_small_label"])}
                            </option>
                            <option value="medium">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.pricing_table.product_title_size_medium_label"])}
                            </option>
                            <option value="large">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.pricing_table.product_title_size_large_label"])}
                            </option>
                        </select>
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.pricing_table.product_title_size_description"
                                defaultMessage="This will change the size of the product title"
                            />
                        </small>
                    </div>
                </div>
                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="showTaxes"
                                name="showTaxes"
                                value={this.state.showTaxes}
                                checked={this.state.showTaxes}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="showTaxes">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.show_taxes_label"
                                    defaultMessage="Show tax details"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.show_taxes_description"
                                    defaultMessage="This will show the details of each tax with their total amount"
                                />
                            </small>
                        </div>
                    </div>
                </div>
                {!this.state.showCustomLine &&
                    <div className="row">
                        <div className="col-2" />
                        <div className="col-10">
                            <div className="custom-control custom-checkbox">
                                <input
                                    className="custom-control-input"
                                    type="checkbox"
                                    id="showLineSubTotal"
                                    name="showLineSubTotal"
                                    value={this.state.showLineSubTotal}
                                    checked={this.state.showLineSubTotal}
                                    onChange={this.handleFormChange}
                                />
                                <label className="custom-control-label" htmlFor="showLineSubTotal">
                                    <FormattedMessage
                                        id="templates.sections.form.edit.content.pricing_table.show_line_sub_totals_label"
                                        defaultMessage="Show line subtotals"
                                    />
                                </label>
                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="templates.sections.form.edit.content.pricing_table.show_line_sub_totals_description"
                                        defaultMessage="This will show the total amount of each line"
                                    />
                                </small>
                            </div>
                        </div>
                    </div>
                }
                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="showGroupDescription"
                                name="showGroupDescription"
                                value={this.state.showGroupDescription}
                                checked={this.state.showGroupDescription}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="showGroupDescription">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.show_description_label"
                                    defaultMessage="Show group description"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.show_description_description"
                                    defaultMessage="This will show the description of each group"
                                />
                            </small>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        {AppContext.getAccount()?.attributes?.isTaxInclusive &&
                            <div className="custom-control custom-checkbox">
                                <input
                                    className="custom-control-input"
                                    type="checkbox"
                                    id="showGroupInclusiveSubtotal"
                                    name="showGroupInclusiveSubtotal"
                                    value={this.state.showGroupInclusiveSubtotal}
                                    checked={this.state.showGroupInclusiveSubtotal}
                                    onChange={this.handleFormChange}
                                />
                                <label className="custom-control-label" htmlFor="showGroupInclusiveSubtotal">
                                    <FormattedMessage
                                        id="templates.sections.form.edit.content.pricing_table.show_group_subtotal_inclusive_label"
                                        defaultMessage="Show inclusive subtotal for each group"
                                    />
                                </label>
                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="templates.sections.form.edit.content.pricing_table.show_group_subtotal_inclusive_description"
                                        defaultMessage="This will show each group's subtotal with the inclusive amount"
                                    />
                                </small>
                            </div>
                        }
                    </div>
                </div>
                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="showShortDescription"
                                name="showShortDescription"
                                value={this.state.showShortDescription}
                                checked={this.state.showShortDescription}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="showShortDescription">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.show_short_description_label"
                                    defaultMessage="Show product short description"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.show_short_description_description"
                                    defaultMessage="This will show the short description of the product from the catalog on each line"
                                />
                            </small>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="showLongDescription"
                                name="showLongDescription"
                                value={this.state.showLongDescription}
                                checked={this.state.showLongDescription}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="showLongDescription">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.show_long_description_label"
                                    defaultMessage="Show product long description"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.show_long_description_description"
                                    defaultMessage="This will show the long description of the product from the catalog on each line"
                                />
                            </small>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="showProductPageUrl"
                                name="showProductPageUrl"
                                value={this.state.showProductPageUrl}
                                checked={this.state.showProductPageUrl}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="showProductPageUrl">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.show_product_page_url_label"
                                    defaultMessage="Enable line item title as hyperlink"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.show_product_page_url_description"
                                    defaultMessage="If enabled, clicking on the title of the line item will open a new tab to the product page url"
                                />
                            </small>
                        </div>
                    </div>
                </div>
                {
                    !this.state.showCustomLine &&
                    <>
                        <SectionSettingCheckbox
                            id="showUnitPrice"
                            name="showUnitPrice"
                            value={this.state.showUnitPrice}
                            isChecked={this.state.showUnitPrice}
                            onChange={this.handleFormChange}
                            message={this.props.intl.formatMessage({
                                id: "templates.sections.form.edit.content.pricing_table.show_unit_price_label",
                                defaultMessage: "Show unit price on line item"
                            })}
                            description={this.props.intl.formatMessage({
                                id: "templates.sections.form.edit.content.pricing_table.show_unit_price_description",
                                defaultMessage: "This will show the unit price including discount on each line"
                            })}
                        />
                        <SectionSettingCheckbox
                            id="showUnitPriceWithoutDiscount"
                            name="showUnitPriceWithoutDiscount"
                            value={this.state.showUnitPriceWithoutDiscount}
                            isChecked={this.state.showUnitPriceWithoutDiscount}
                            onChange={this.handleFormChange}
                            message={this.props.intl.formatMessage({
                                id: "templates.sections.form.edit.content.pricing_table.show_unit_price_without_discount_label",
                                defaultMessage: "Show unit price on line item without discount"
                            })}
                            description={this.props.intl.formatMessage({
                                id: "templates.sections.form.edit.content.pricing_table.show_unit_price_without_discount_description",
                                defaultMessage: "This will show the unit price without discount on each line"
                            })}
                        />
                        <SectionSettingCheckbox
                            id="showSku"
                            name="showSku"
                            value={this.state.showSku}
                            isChecked={this.state.showSku}
                            onChange={this.handleFormChange}
                            message={this.props.intl.formatMessage({
                                id: "templates.sections.form.edit.content.pricing_table.show_sku_label",
                                defaultMessage: "Show sku on line item"
                            })}
                            description={this.props.intl.formatMessage({
                                id: "templates.sections.form.edit.content.pricing_table.show_sku_description",
                                defaultMessage: "This will show the sku of the product on each line"
                            })}
                        />
                        <SectionSettingCheckbox
                            id="showBundleSkus"
                            name="showBundleSkus"
                            value={this.state.showBundleSkus}
                            isChecked={this.state.showBundleSkus}
                            onChange={this.handleFormChange}
                            message={this.props.intl.formatMessage({
                                id: "templates.sections.form.edit.content.pricing_table.show_bundle_skus_label",
                                defaultMessage: "Show bundle item skus"
                            })}
                            description={this.props.intl.formatMessage({
                                id: "templates.sections.form.edit.content.pricing_table.show_sku_description",
                                defaultMessage: "This will show the sku of the product on each line"
                            })}
                        />
                        <SectionSettingCheckbox
                            id="showManufacturer"
                            name="showManufacturer"
                            value={this.state.showManufacturer}
                            isChecked={this.state.showManufacturer}
                            onChange={this.handleFormChange}
                            message={this.props.intl.formatMessage({
                                id: "templates.sections.form.edit.content.pricing_table.show_manufacturer_label",
                                defaultMessage: "Show manufacturer on line item"
                            })}
                            description={this.props.intl.formatMessage({
                                id: "templates.sections.form.edit.content.pricing_table.show_manufacturer_description",
                                defaultMessage: "This will show the manufacturer of the product on each line"
                            })}
                        />
                        <SectionSettingCheckbox
                            id="showProductLabels"
                            name="showProductLabels"
                            value={this.state.showProductLabels}
                            isChecked={this.state.showProductLabels}
                            onChange={this.handleFormChange}
                            message={this.props.intl.formatMessage({
                                id: "templates.sections.form.edit.content.pricing_table.show_product_labels_label",
                                defaultMessage: "Show product labels on line item"
                            })}
                            description={this.props.intl.formatMessage({
                                id: "templates.sections.form.edit.content.pricing_table.show_product_labels_description",
                                defaultMessage: "This will show the product labels on each line"
                            })}
                        />
                        <SectionSettingCheckbox
                            id="showVendorLabels"
                            name="showVendorLabels"
                            value={this.state.showVendorLabels}
                            isChecked={this.state.showVendorLabels}
                            onChange={this.handleFormChange}
                            message={this.props.intl.formatMessage({
                                id: "templates.sections.form.edit.content.pricing_table.show_vendor_labels_label",
                                defaultMessage: "Show vendor labels on line item"
                            })}
                            description={this.props.intl.formatMessage({
                                id: "templates.sections.form.edit.content.pricing_table.show_vendor_labels_description",
                                defaultMessage: "This will show the vendor labels on each line"
                            })}
                        />
                        <SectionSettingCheckbox
                            id="showBrandLabel"
                            name="showBrandLabel"
                            value={this.state.showBrandLabel}
                            isChecked={this.state.showBrandLabel}
                            onChange={this.handleFormChange}
                            message={this.props.intl.formatMessage({
                                id: "templates.sections.form.edit.content.pricing_table.show_brand_label",
                                defaultMessage: "Show brand label on line item"
                            })}
                            description={this.props.intl.formatMessage({
                                id: "templates.sections.form.edit.content.pricing_table.show_brand_label_description",
                                defaultMessage: "This will show the brand label on each line, by the product name."
                            })}
                        />
                    </>
                }
                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="hideSerialNumber"
                                name="hideSerialNumber"
                                value={this.state.hideSerialNumber}
                                checked={this.state.hideSerialNumber}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="hideSerialNumber">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_serial_number"
                                    defaultMessage="Hide serial numbers"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_serial_number_description"
                                    defaultMessage="This will hide any serial number attached to the line item"
                                />
                            </small>
                        </div>
                    </div>
                </div>
                {
                    !GlobalHelper.hasShopifyIntegrationWithDisabledFeatures() &&
                    <div className="row">
                        <div className="col-2" />
                        <div className="col-10">
                            <div className="custom-control custom-checkbox">
                                <input
                                    className="custom-control-input"
                                    type="checkbox"
                                    id="hideDeposit"
                                    name="hideDeposit"
                                    value={this.state.hideDeposit}
                                    checked={this.state.hideDeposit}
                                    onChange={this.handleFormChange}
                                />
                                <label className="custom-control-label" htmlFor="hideDeposit">
                                    <FormattedMessage
                                        id="templates.sections.form.edit.content.pricing_table.hide_deposit_label"
                                        defaultMessage="Hide deposit"
                                    />
                                </label>
                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="templates.sections.form.edit.content.pricing_table.hide_deposit_description"
                                        defaultMessage="This will hide the deposit amount from the total"
                                    />
                                </small>
                            </div>
                        </div>
                    </div>
                }
                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="hideImages"
                                name="hideImages"
                                value={this.state.hideImages}
                                checked={this.state.hideImages}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="hideImages">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_images_label"
                                    defaultMessage="Hide images"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_images_description"
                                    defaultMessage="This will hide images on each line"
                                />
                            </small>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="hideFiles"
                                name="hideFiles"
                                value={this.state.hideFiles}
                                checked={this.state.hideFiles}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="hideFiles">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_files_label"
                                    defaultMessage="Hide files"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_files_description"
                                    defaultMessage="This will hide files on each line"
                                />
                            </small>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="hideTotals"
                                name="hideTotals"
                                value={this.state.hideTotals}
                                checked={this.state.hideTotals}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="hideTotals">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_totals_label"
                                    defaultMessage="Hide totals"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_totals_description"
                                    defaultMessage="This will hide the full total section"
                                />
                            </small>
                        </div>
                    </div>
                </div>
                {
                    !this.state.hideTotals &&
                    <div className="row">
                        <div className="col-2" />
                        <div className="col-10">
                            <div className="custom-control custom-checkbox">
                                <input
                                    className="custom-control-input"
                                    type="checkbox"
                                    id="showTotalQuantitiesByUnitGroup"
                                    name="showTotalQuantitiesByUnitGroup"
                                    checked={this.state.showTotalQuantitiesByUnitGroup}
                                    onChange={this.handleFormChange}
                                />
                                <label className="custom-control-label pr-2" htmlFor="showTotalQuantitiesByUnitGroup">
                                    <FormattedMessage
                                        id="templates.sections.form.edit.content.pricing_table.show_total_quantities_label"
                                        defaultMessage="Show total quantity by"
                                    />
                                </label>
                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="templates.sections.form.edit.content.pricing_table.show_total_quantities_description"
                                        defaultMessage="This will show the total quantity for the selected group(s) of unit type"
                                    />
                                </small>

                                <Select
                                    multi={true}
                                    placeholder={this.props.intl.formatMessage(messages["quantity_group_select_placeholder"])}
                                    value={this.state.unitGroupsToDisplay}
                                    options={this.state.defaultUnitGroupsToDisplay}
                                    onChange={this.handleQuantitiesSelectChange}
                                    clearable={false}
                                    disabled={!this.state.showTotalQuantitiesByUnitGroup}
                                    className="drop-up"
                                />
                            </div>
                        </div>
                    </div>
                }
                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="hideGroupSubtotal"
                                name="hideGroupSubtotal"
                                value={this.state.hideGroupSubtotal}
                                checked={this.state.hideGroupSubtotal}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="hideGroupSubtotal">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_group_subtotal_label"
                                    defaultMessage="Hide group subtotal"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.show_hide_subtotal_label_description"
                                    defaultMessage="This will hide the subtotal of each group"
                                />
                            </small>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="hideDueDate"
                                name="hideDueDate"
                                value={this.state.hideDueDate}
                                checked={this.state.hideDueDate}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="hideDueDate">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_due_date_label"
                                    defaultMessage="Hide due date"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_due_date_description"
                                    defaultMessage="This will hide the due date."
                                />
                            </small>
                        </div>
                    </div>
                </div>

                {/*  HIDE CALENDAR EVENTS */}
                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="hideCalendarEvents"
                                name="hideCalendarEvents"
                                value={this.state.hideCalendarEvents}
                                checked={this.state.hideCalendarEvents}
                                onChange={this.handleFormChange}
                            />

                            <label className="custom-control-label" htmlFor="hideCalendarEvents">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_calendar_events_label"
                                    defaultMessage="Hide group events"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_calendar_events_description"
                                    defaultMessage="Group calendar events will be hidden"
                                />
                            </small>
                        </div>
                    </div>
                </div>


                {/*  HIDE ITEMS  */}
                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="hideItems"
                                name="hideItems"
                                value={this.state.hideItems}
                                checked={this.state.hideItems}
                                onChange={this.handleFormChange}
                            />

                            <label className="custom-control-label" htmlFor="hideItems">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_items_label"
                                    defaultMessage="Hide items"
                                />
                            </label>

                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.hide_items_label_description"
                                    defaultMessage="All products informations will be hidden"
                                />
                            </small>
                        </div>
                    </div>
                </div>

                {/*  DISABLE INTERACTIVE OPTIONS */}
                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="disableInteractive"
                                name="disableInteractive"
                                value={this.state.disableInteractive}
                                checked={this.state.disableInteractive}
                                onChange={this.handleFormChange}
                            />

                            <label className="custom-control-label" htmlFor="disableInteractive">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.disable_interactive_label"
                                    defaultMessage="Disable interactions"
                                />
                            </label>

                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.disable_interactive_label_description"
                                    defaultMessage="This will disable interactive options"
                                />
                            </small>
                        </div>
                    </div>
                </div>

                {/* Custom line */}
                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="showCustomLine"
                                name="showCustomLine"
                                value={this.state.showCustomLine}
                                checked={this.state.showCustomLine}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="showCustomLine">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.show_custom_line_label"
                                    defaultMessage="Show custom line"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.show_custom_line_label_description"
                                    defaultMessage="This will show the custom line instead of the default line"
                                />
                            </small>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="enableCollapsibleGroups"
                                name="enableCollapsibleGroups"
                                value={this.state.enableCollapsibleGroups}
                                checked={this.state.enableCollapsibleGroups}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="enableCollapsibleGroups">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.enable_collapsible_groups_label"
                                    defaultMessage="Make groups collapsible"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.pricing_table.enable_collapsible_groups_label_description"
                                    defaultMessage="This will make groups collapsible"
                                />
                            </small>
                        </div>
                    </div>
                </div>
                {
                    this.state.enableCollapsibleGroups &&
                    <div className="row">
                        <div className="col-2" />
                        <div className="col-10">
                            <div className="custom-control custom-checkbox">
                                <input
                                    className="custom-control-input"
                                    type="checkbox"
                                    id="enableSingleCollapsibleGroups"
                                    name="enableSingleCollapsibleGroups"
                                    value={this.state.enableSingleCollapsibleGroups}
                                    checked={this.state.enableSingleCollapsibleGroups}
                                    onChange={this.handleFormChange}
                                />
                                <label className="custom-control-label" htmlFor="enableSingleCollapsibleGroups">
                                    <FormattedMessage
                                        id="templates.sections.form.edit.content.pricing_table.enable_single_collapsible_groups_label"
                                        defaultMessage="Expand a single group at a time"
                                    />
                                </label>
                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="templates.sections.form.edit.content.pricing_table.enable_single_collapsible_groups_label_description"
                                        defaultMessage="Only one group will be expanded and visible, while all other groups will be collapsed and hidden"
                                    />
                                </small>
                            </div>
                        </div>
                    </div>
                }


                {
                    this.state.showCustomLine && [
                        <div className="form-group row mb-4">
                            <div className="col-12">
                                <table className="table mt-3 table-sm mb-0">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "10%" }} scope="col" className="text-left border-top-0">
                                                <small className="font-weight-bold">{
                                                    this.state.customLineHeaderLabel1 || this.props.intl.formatMessage(messages["preview_header_label"]) + ' 1'}
                                                </small>
                                            </th>
                                            <th style={{ width: "40%" }} scope="col" className="text-left border-top-0">
                                                <small className="font-weight-bold">{
                                                    this.state.customLineHeaderLabel2 || this.props.intl.formatMessage(messages["preview_header_label"]) + ' 2'}
                                                </small>
                                            </th>
                                            <th style={{ width: "30%" }} scope="col" className="text-right border-top-0">
                                                <small className="font-weight-bold">{
                                                    this.state.customLineHeaderLabel3 || this.props.intl.formatMessage(messages["preview_header_label"]) + ' 3'}
                                                </small>
                                            </th>
                                            <th style={{ width: "20%" }} scope="col" className="text-right border-top-0">
                                                <small className="font-weight-bold">{
                                                    this.state.customLineHeaderLabel4 || this.props.intl.formatMessage(messages["preview_header_label"]) + ' 4'}
                                                </small>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style={{ width: "10%" }}>
                                                <div className="rich-text text-left">
                                                    <small>{<div dangerouslySetInnerHTML={{
                                                        __html: ProposalMergeFields.mergePricingTableLine(
                                                            this.state.customLineText1,
                                                            {},
                                                            true)
                                                    }} />}</small>
                                                </div>
                                            </td>
                                            <td style={{ width: "40%" }}>
                                                <div className="rich-text text-left">
                                                    <small>{<div dangerouslySetInnerHTML={{
                                                        __html: ProposalMergeFields.mergePricingTableLine(
                                                            this.state.customLineText2,
                                                            {},
                                                            true)
                                                    }} />}</small>
                                                </div>
                                            </td>
                                            <td style={{ width: "30%" }}>
                                                <div className="rich-text text-right">
                                                    <small>{<div dangerouslySetInnerHTML={{
                                                        __html: ProposalMergeFields.mergePricingTableLine(
                                                            this.state.customLineText3,
                                                            {},
                                                            true)
                                                    }} />}</small>
                                                </div>
                                            </td>
                                            <td style={{ width: "20%" }}>
                                                <div className="rich-text text-right">
                                                    <small>{<div dangerouslySetInnerHTML={{
                                                        __html: ProposalMergeFields.mergePricingTableLine(
                                                            this.state.customLineText4,
                                                            {},
                                                            true)
                                                    }} />}</small>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>,
                        <div className="form-group row">
                            <div className="col-2 col-form-label text-align-right">
                                <label className="mb-1">
                                    <FormattedMessage
                                        id="templates.sections.form.edit.content.pricing_table.header_label"
                                        defaultMessage="Header {number}"
                                        values={{
                                            number: '1'
                                        }}
                                    />
                                </label>
                            </div>
                            <div className="col-10">
                                <input
                                    name={'customLineHeaderLabel1'}
                                    value={this.state.customLineHeaderLabel1}
                                    onChange={this.handleFormChange}
                                    id={'customLineHeaderLabel1'}
                                    type="text"
                                    className="form-control mb-2"
                                    placeholder={this.props.intl.formatMessage(messages["header_label_placeholder"])}
                                />
                                <RichTextEditor
                                    enableMergeFields={true}
                                    pricingTableMergeFieldsOnly={true}
                                    height={75}
                                    name="customLineText1"
                                    value={this.state.customLineText1}
                                    onChange={this.handleTextChangeColumn1}
                                    id="customLineText1"
                                    className="form-control"
                                />
                            </div>
                        </div>,

                        <div className="form-group row">
                            <div className="col-2 col-form-label text-align-right">
                                <label className="mb-1">
                                    <FormattedMessage
                                        id="templates.sections.form.edit.content.pricing_table.header_label"
                                        defaultMessage="Header {number}"
                                        values={{
                                            number: '2'
                                        }}
                                    />
                                </label>
                            </div>
                            <div className="col-10">
                                <input
                                    name={'customLineHeaderLabel2'}
                                    value={this.state.customLineHeaderLabel2}
                                    onChange={this.handleFormChange}
                                    id={'customLineHeaderLabel2'}
                                    type="text"
                                    className="form-control mb-2"
                                    placeholder={this.props.intl.formatMessage(messages["header_label_placeholder"])}
                                />
                                <RichTextEditor
                                    enableMergeFields={true}
                                    pricingTableMergeFieldsOnly={true}
                                    height={75}
                                    name="customLineText2"
                                    value={this.state.customLineText2}
                                    onChange={this.handleTextChangeColumn2}
                                    id="customLineText2"
                                    className="form-control"
                                />
                            </div>
                        </div>,

                        <div className="form-group row">
                            <div className="col-2 col-form-label text-align-right">
                                <label className="mb-1">
                                    <FormattedMessage
                                        id="templates.sections.form.edit.content.pricing_table.header_label"
                                        defaultMessage="Header {number}"
                                        values={{
                                            number: '3'
                                        }}
                                    />
                                </label>
                            </div>
                            <div className="col-10">
                                <input
                                    name={'customLineHeaderLabel3'}
                                    value={this.state.customLineHeaderLabel3}
                                    onChange={this.handleFormChange}
                                    id={'customLineHeaderLabel3'}
                                    type="text"
                                    className="form-control mb-2"
                                    placeholder={this.props.intl.formatMessage(messages["header_label_placeholder"])}
                                />
                                <RichTextEditor
                                    enableMergeFields={true}
                                    pricingTableMergeFieldsOnly={true}
                                    height={75}
                                    name="customLineText3"
                                    value={this.state.customLineText3}
                                    onChange={this.handleTextChangeColumn3}
                                    id="customLineText3"
                                    className="form-control"
                                />
                            </div>
                        </div>,

                        <div className="form-group row">
                            <div className="col-2 col-form-label text-align-right">
                                <label className="mb-1">
                                    <FormattedMessage
                                        id="templates.sections.form.edit.content.pricing_table.header_label"
                                        defaultMessage="Header {number}"
                                        values={{
                                            number: '4'
                                        }}
                                    />
                                </label>
                            </div>
                            <div className="col-10">
                                <input
                                    name={'customLineHeaderLabel4'}
                                    value={this.state.customLineHeaderLabel4}
                                    onChange={this.handleFormChange}
                                    id={'customLineHeaderLabel4'}
                                    type="text"
                                    className="form-control mb-2"
                                    placeholder={this.props.intl.formatMessage(messages["header_label_placeholder"])}
                                />
                                <RichTextEditor
                                    enableMergeFields={true}
                                    pricingTableMergeFieldsOnly={true}
                                    height={75}
                                    name="customLineText4"
                                    value={this.state.customLineText4}
                                    onChange={this.handleTextChangeColumn4}
                                    id="customLineText4"
                                    className="form-control"
                                />
                            </div>
                        </div>]
                }
            </div >
        );
    }
}

export default injectIntl(PricingTableContentInput)


// WEBPACK FOOTER //
// ./src/template/sections/content/pricing-table/input.component.jsx